<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_11">The Mystery of the Blue Train</a></h1><a id="page_11">
<p class="titlea">A Hercule Poirot Mystery</p>
<p class="titlea">Agatha Christie</p>
</a><p class="centerimg"><a id="page_11"><img alt="image" src="image/logo3.jpg"/></a><a id="page_ii"></a></p><a id="page_ii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?0adae9f6